// extracted by mini-css-extract-plugin
module.exports = {"collection":"Collection_collection__2d6tJ","collectionbox":"Collection_collectionbox__1VYw2"};